import React, { useEffect, useState, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import authService from "../../Common/services";
import { ActiveUserGrid } from '../Components/activeUsers';
import { CollectionGrid } from '../Components/collection';
import { OnGoingGrid } from '../Components/onGoing';
import { MasterCardGrid } from '../Components/masterCard';
import { ChartCollectionByDayGrid } from '../Components/collectionByDayGrid';
import { ChartCollectionByMonthGrid } from '../Components/collectionByMonth';
import { ChartCollectionCategoryByDayGrid } from '../Components/collectionCategoryByDay';
import { ChartCollectionCategoryByMonthGrid } from '../Components/collectionCategoryByMonth';
import { ChartCollectionByMonthlyGrid } from '../Components/collectionCategoryMonthly';
import { ChartCollectionCategoryByYearGrid } from '../Components/collectionCategoryByYear';
import { ChartEstatetCollectionByDayGrid } from '../Components/estateCollectionByDayGrid';
import { ChartEstateCollectionByMonthGrid } from '../Components/estateCollectionByMonth';
import { ActivePluckersGrid } from '../Components/activePluckers';
import { ActualCollectionGrid } from '../Components/actualCollection';
import { CheckRoleCollectionGrid } from '../Components/checkRoleCollection';
import { ChartDivisionCollectionByMonthGrid } from '../Components/divisionCollectionByMonth';
import { CheckRoleGtnGrnVariance } from '../Components/checkRoleGtnGrnVariance';
import Grid from '@material-ui/core/Grid';
import services from '../services';
import Select from "@material-ui/core/Select";
import groupServices from '../../Group/services';
import MenuItem from '@material-ui/core/MenuItem';
import { LoadingSpinerComponent } from '../../../Common/loader';
import { DashboardSchemaObject } from '../dashboardSchema';
import { validateProperty, validate } from "../../Common";
import InputLabel from '@material-ui/core/InputLabel';
import tokenService from '../../../Common/tokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { fromCallback } from 'bluebird';

const screenCode = "DASHBOARD";

const useStyles = makeStyles({

    root: {
        flexGrow: 1,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
        color: "#229954"
    },
    pos: {
        marginBottom: 12,
    },
    card: {
        flexGrow: 1,
        backgroundColor: "#ffffff",
        paddingInlineStart: '10px',
        borderRadius: '10px',
        boxShadow: ' 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)',
        maxHeight: 300,
        height: 200
    },

});
export function MainGrid(props) {

    const classes = useStyles();
    const [dashboardData, setDashboardData] = useState({
        groupID: '0',
        operationEntityID: '0'
    });
    const [errors, setErrors] = useState({});
    const [groups, setGroups] = useState([]);
    const [operationEntites, setOperationEntites] = useState([]);
    const [activeUserData, setActiveUserData] = useState({
        dailyActiveUsers: 0,
        monthlyActiveUsers: 0
    });

    const [activePluckersData, setActivePluckersData] = useState({
        dailyActivePluckers: 0,
        monthlyActivePluckers: 0
    });

    const [collectionData, setCollectionData] = useState({
        dailyCollectionNetAmount: 0,
        monthlyCollectionNetAmount: 0
    });

    const [actualCollectionData, setActualCollectionData] = useState({
        dailyActualCollectionNetAmount: 0,
        monthlyActualCollectionNetAmount: 0
    });

    const [checkRoleCollection, setCheckRoleCollection] = useState({
        dailyCheckRoleCollectionAmount: 0,
        monthlyCheckRoleCollectionAmount: 0
    });

    const [onGoingGrid, setOnGoingGrid] = useState({
        activeRoutes: 0,
        activeSessions: 0
    });

    const [masterCard, setMasterCard] = useState({
        masterCardCustomerCountDaily: 0,
        masterCardCustomerCountMonthly: 0,
        masterCardTotalAmountDaily: 0,
        masterCardTotalAmountMonthly: 0
    });

    const [collectionByDayData, setCollectionByDayData] = useState({
        labels: [],
        datasets: []
    });

    const [estateCollectionByDayData, setEstateCollectionByDayData] = useState({
        labels: [],
        datasets: []
    });

    const [collectionByMonthData, setCollectionByMonthData] = useState({
        labels: [],
        datasets: []
    });

    const [divisionCollectionByMonthData, setDivisionCollectionByMonthData] = useState({
        labels: [],
        datasets: []
    });

    const [estateCollectionByMonthData, setEstateCollectionByMonthData] = useState({
        labels: [],
        datasets: []
    });

    const [collectionCategoryByDayData, setCollectionCategoryByDayData] = useState({
        labels: [],
        datasets: []
    });

    const [collectionCategoryByMonthData, setCollectionCategoryByMonthData] = useState({
        collectionCategoryBarChartData: {
            labels: [],
            datasets: [],
        },
        dougnutChartData: {
            labels: [],
            datasets: [],
        },

    });
    const [collectionCategoryMonthlyData, setCollectionCategoryMonthlyData] = useState({
        labels: [],
        datasets: []
    });
    const [collectionCategoryByYear, setCollectionCategoryByYear] = useState({
        labels: [],
        datasets: []
    });

    const [cheackRollGtnGrnDetails, setCheackRollGtnGrnDetails] = useState([]);

    const [permissionList, setPermissions] = useState({
        isOperationEntityFilterEnabled: false,
        isGroupFilterEnabled: false
    });

    const [isViewStateUserHeader, SetIsViewStateUserHeader] = useState(true);
    const [isViewCollectionByDayGrid, SetIsViewCollectionByDayGrid] = useState(true);
    const [isViewCollectionByMonthGrid, SetIsViewCollectionByMonthGrid] = useState(true);
    const [isViewCollectionCatByDayGrid, SetIsViewCollectionCatByDayGrid] = useState(true);
    const [isCollectionCatByMonthGrid, SetIsCollectionCatByMonthGrid] = useState(true);
    const [isViewCollectionMonthlyGrid, SetIsViewCollectionMonthlyGrid] = useState(true);
    const [isViewCollectionYearlyGrid, SetIsViewCollectionYearlyGrid] = useState(true);
    const [isViewEstateCollectionByDayGrid, SetIsViewEstateCollectionByDayGrid] = useState(true);
    const [isViewEstateCollectionByMonthGrid, SetIsViewEstateCollectionByMonthGrid] = useState(true);
    const [isViewActivePluckersGrid, setIsViewActivePluckersGrid] = useState(true);
    const [isViewActualCollectionGrid, setIsViewActualCollectionGrid] = useState(true);
    const [isViewCheckRoleCollectionGrid, setIsViewCheckRoleCollectionGrid] = useState(true);
    const [isViewDivisionCollectionByMonthGrid, SetIsViewDivisionCollectionByMonthGrid] = useState(true);
    const [isViewCheackRollGtnGrnDetailsGrid, SetIsViewCheackRollGtnGrnDetailsGrid] = useState(true);

    useEffect(() => {
        getPermissions();
        getGroups();
    }, []);

    useEffect(() => {
        if (dashboardData.groupID > 0) {
            getOperationEntitesByGroupID();
        }

    }, [dashboardData.groupID]);

    useEffect(() => {
        if (dashboardData.operationEntityID > 0) {
            trackPromise(setAllDashboardData());
        }
    }, [dashboardData.operationEntityID])

    async function getGroups() {
        var result = await groupServices.getGroupsForDropdown();
        setGroups(result);
    }

    async function getOperationEntitesByGroupID() {
        var result = await services.getOperationalEntityByGroupEntityID(dashboardData.groupID);
        setOperationEntites(result);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(
            (p) => p.permissionCode == "VIEWDASHBOARD"
        );

        var isViewStateDashBoard = permissions.find(
            (p) => p.permissionCode == "VIEWSTATEDASHBOARD"
        );

        var isViewCollectionByDay = permissions.find(
            (p) => p.permissionCode == "VIEWCOLLECTIONBYDAY"
        );
        var isViewCollectionByMonth = permissions.find(
            (p) => p.permissionCode == "VIEWCOLLECTIONBYMONTH"
        );

        var isViewCollectionCatByDay = permissions.find(
            (p) => p.permissionCode == "VIEWCOLLECTIONCATBYDAY"
        );

        var isCollectionCatByMonth = permissions.find(
            (p) => p.permissionCode == "VIEWCOLLECTIONCATBYMONTH"
        );

        var isViewCollectionMonthly = permissions.find(
            (p) => p.permissionCode == "VIEWCOLLECTIONMONTHLY"
        );
        var isViewCollectionYearly = permissions.find(
            (p) => p.permissionCode == "VIEWCOLLECTIONYEARLY"
        );

        var isViewEstateCollectionByDay = permissions.find(
            (p) => p.permissionCode == "VIEWESTATECOLLECTIONBYDAY"
        );

        var isViewEstateCollectionMonthly = permissions.find(
            (p) => p.permissionCode == "VIEWESTATECOLLECTIONBYMONTH"
        );

        var isViewActivePluckers = permissions.find(
            (p) => p.permissionCode == "VIEWESTATEACTIVEPLUCKERS"
        );

        var isViewActualCollection = permissions.find(
            (p) => p.permissionCode == "VIEWESTATEACTUALCOLLECTION"
        );

        var isViewCheckRoleCollection = permissions.find(
            (p) => p.permissionCode == "VIEWESTATECHECKROLECOLLECTION"
        );

        var isViewDivisionCollectionByMonth = permissions.find(
            (p) => p.permissionCode == "VIEWESTATEDIVISIONCOLLECTIONBYMONTH"
        );

        var isViewCheackRollGtnGrnDetails = permissions.find(
            (p) => p.permissionCode == "VIEWCHECKROLLGTNGRNVARIANCE"
        );

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined,
            isViewStateDashBoard: isViewStateDashBoard !== undefined,
            isViewCollectionByDay: isViewCollectionByDay !== undefined,
            isViewCollectionByMonth: isViewCollectionByMonth !== undefined,
            isViewCollectionCatByDay: isViewCollectionCatByDay !== undefined,
            isCollectionCatByMonth: isCollectionCatByMonth !== undefined,
            isViewCollectionMonthly: isViewCollectionMonthly !== undefined,
            isViewCollectionYearly: isViewCollectionYearly !== undefined,
            isViewEstateCollectionByDay: isViewEstateCollectionByDay !== undefined,
            isViewEstateCollectionMonthly: isViewEstateCollectionMonthly !== undefined,
            isViewActivePluckers: isViewActivePluckers !== undefined,
            isViewActualCollection: isViewActualCollection !== undefined,
            isViewCheckRoleCollection: isViewCheckRoleCollection !== undefined,
            isViewDivisionCollectionByMonth: isViewDivisionCollectionByMonth !== undefined,
            isViewCheackRollGtnGrnDetails: isViewCheackRollGtnGrnDetails !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();

        setDashboardData({
            ...dashboardData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        if (isAuthorized === undefined) {
            props.history.push("/unauthorized");
        }
    }

    async function setAllDashboardData() {
        if (permissionList.isViewStateDashBoard === false) {
            SetIsViewStateUserHeader(false);

        } else {
            getDashBoardDetails(dashboardData.operationEntityID);
        }

        if (permissionList.isViewCollectionByDay === false) {
            SetIsViewCollectionByDayGrid(false);

        } else {
            setChartData(dashboardData.operationEntityID);
        }

        if (permissionList.isViewCollectionByMonth === false) {
            SetIsViewCollectionByMonthGrid(false);

        } else {
            setBarData(dashboardData.operationEntityID);
        }

        if (permissionList.isViewCollectionCatByDay === false) {
            SetIsViewCollectionCatByDayGrid(false);

        } else {
            setCategoryByDay(dashboardData.operationEntityID);
        }

        if (permissionList.isViewCollectionMonthly === false) {
            SetIsViewCollectionMonthlyGrid(false);

        } else {
            setCategoryByMonthly(dashboardData.operationEntityID);
        }

        if (permissionList.isCollectionCatByMonth === false) {
            SetIsCollectionCatByMonthGrid(false);

        } else {
            setCategoryByMonth(dashboardData.operationEntityID);
        }

        if (permissionList.isViewCollectionYearly === false) {
            SetIsViewCollectionYearlyGrid(false);

        } else {
            SetCollectionCategoryByYear(dashboardData.operationEntityID);
        }

        if (permissionList.isViewEstateCollectionByDay === false) {
            SetIsViewEstateCollectionByDayGrid(false);
        } else {
            setEstateByDay(dashboardData.operationEntityID);
        }

        if (permissionList.isViewEstateCollectionMonthly === false) {
            SetIsViewEstateCollectionByMonthGrid(false);
        } else {
            setEstateByMonth(dashboardData.operationEntityID);
        }

        if (permissionList.isViewActivePluckers === false) {
            setIsViewActivePluckersGrid(false);
        } else {
            setActivePluckers(dashboardData.operationEntityID);
        }

        if (permissionList.isViewActualCollection === false) {
            setIsViewActualCollectionGrid(false);
        } else {
            setActualCollection(dashboardData.operationEntityID);
        }

        if (permissionList.isViewCheckRoleCollection === false) {
            setIsViewCheckRoleCollectionGrid(false);
        } else {
            setCheckRoleCollectionData(dashboardData.operationEntityID);
        }

        if (permissionList.isViewDivisionCollectionByMonth === false) {
            SetIsViewDivisionCollectionByMonthGrid(false);
        } else {
            SetDivisionCollectionByMonth(dashboardData.operationEntityID);
        }

        if (permissionList.isViewCheackRollGtnGrnDetails === false) {
            SetIsViewCheackRollGtnGrnDetailsGrid(false);
        } else {
            SetCheackRollGtnGrnDetails(dashboardData.operationEntityID);
        }
    }

    async function getDashBoardDetails(operationEntityID) {
        const result = await services.dashBoardData(operationEntityID);

        setActiveUserData({
            dailyActiveUsers: result.dailyActiveUsers,
            monthlyActiveUsers: result.monthlyActiveUsers
        });

        setCollectionData({
            dailyCollectionNetAmount: result.dailyCollectionNetAmount,
            monthlyCollectionNetAmount: result.monthlyCollectionNetAmount
        });

        setOnGoingGrid({
            activeRoutes: result.activeRoutes,
            activeSessions: result.activeSessions
        });

        setMasterCard({
            masterCardCustomerCountDaily: result.masterCardCustomerCountDaily,
            masterCardCustomerCountMonthly: result.masterCardCustomerCountMonthly,
            masterCardTotalAmountDaily: result.masterCardTotalAmountDaily,
            masterCardTotalAmountMonthly: result.masterCardTotalAmountMonthly
        });
    }

    async function setChartData(operationEntityID) {
        const lineChartData = await services.getCollectionGroupByDay(operationEntityID);

        setCollectionByDayData(lineChartData);
    }

    async function setBarData(operationEntityID) {
        const barChartData = await services.getCollectionsGroupByMonth(operationEntityID);

        setCollectionByMonthData(barChartData);
    }

    async function setCategoryByDay(operationEntityID) {
        const catData = await services.GetCollectionCategoryTotalAmountByDay(operationEntityID);

        setCollectionCategoryByDayData(catData);
    }

    async function setCategoryByMonth(operationEntityID) {
        const catData = await services.GetCollectionCategoryDataOfMonth(operationEntityID);

        setCollectionCategoryByMonthData(catData);
    }

    async function setCategoryByMonthly(operationEntityID) {
        const data = await services.GetCollectionCategoryTotalAmountMonthly(operationEntityID);

        setCollectionCategoryMonthlyData(data);
    }

    async function SetCollectionCategoryByYear(operationEntityID) {
        const data = await services.GetCollectionCategoryByYear(operationEntityID);

        setCollectionCategoryByYear(data);
    }

    async function setEstateByDay(operationEntityID) {
        const lineChartData = await services.getEstateCollectionGroupByDay(operationEntityID);
        setEstateCollectionByDayData(lineChartData);
    }

    async function setEstateByMonth(operationEntityID) {
        const barChartData = await services.getEstateCollectionsGroupByMonth(operationEntityID);
        setEstateCollectionByMonthData(barChartData);
    }

    async function setActivePluckers(operationEntityID) {
        const data = await services.GetActivePluckers(operationEntityID);
        setActivePluckersData(data);
    }

    async function setActualCollection(operationEntityID) {
        const data = await services.GetActualCollectionAmount(operationEntityID);
        setActualCollectionData(data);
    }

    async function setCheckRoleCollectionData(operationEntityID) {
        const data = await services.GetCheckRoleCollectionAmount(operationEntityID);
        setCheckRoleCollection(data);
    }

    async function SetDivisionCollectionByMonth(operationEntityID) {
        const data = await services.GetEstateCollectionAmountByDivision(operationEntityID);
        setDivisionCollectionByMonthData(data);
    }

    async function SetCheackRollGtnGrnDetails(operationEntityID) {
        const data = await services.GetCheackRollGtnGrnDetailsByOperationEntityID(operationEntityID);
        setCheackRollGtnGrnDetails(data);
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value;

        const error = { ...errors }
        const errorMessage = validateProperty(target, DashboardSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setDashboardData({
            ...dashboardData,
            [e.target.name]: value
        })
        setErrors(error);
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="form-group row">
                <div className="col-md pb-3">
                    <InputLabel shrink id="groupID">Group *</InputLabel>
                    <Select fullWidth
                        label="Group *"
                        name="groupID"
                        id="groupID"
                        value={dashboardData.groupID}
                        disabled={!permissionList.isGroupFilterEnabled}
                        onChange={(e) => handleChange(e)}
                    >
                        <MenuItem value="0">--Select Group--</MenuItem>
                        {generateDropDownMenu(groups)}
                    </Select>
                </div>
                <div className="col-md">
                    <InputLabel shrink id="groupID">Operation Entity *</InputLabel>
                    <Select fullWidth
                        label="Operation Entity "
                        name="operationEntityID"
                        id="operationEntityID"
                        value={dashboardData.operationEntityID}
                        disabled={!permissionList.isOperationEntityFilterEnabled}
                        onChange={(e) => handleChange(e)}
                    >
                        <MenuItem value="0">--All OperationEntities--</MenuItem>
                        {generateDropDownMenu(operationEntites)}
                    </Select>
                </div>
            </div>
            <div className={classes.root}>
                <Grid container spacing={2}>
                    {
                        isViewStateUserHeader == false ?
                            <div>

                            </div>
                            :
                            <>
                                <Grid item xs={12} sm={3}>
                                    <ActiveUserGrid data={activeUserData} />
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <CollectionGrid data={collectionData} />
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <OnGoingGrid data={onGoingGrid} />
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <MasterCardGrid data={masterCard} />
                                </Grid>
                            </>

                    }

                    {
                        isViewCollectionByDayGrid == false ?
                            <></>
                            :
                            <Grid item xs={12} sm={6}>
                                <ChartCollectionByDayGrid chartdata={collectionByDayData} />
                            </Grid>

                    }
                    {
                        isViewCollectionByMonthGrid == false ?
                            <></>
                            :
                            <Grid item xs={12} sm={6}>
                                <ChartCollectionByMonthGrid bardata={collectionByMonthData} />
                            </Grid>

                    }
                    {
                        isViewCollectionCatByDayGrid == false ?
                            <></>
                            :
                            <Grid item xs={12} sm={6}>
                                <ChartCollectionCategoryByDayGrid catData={collectionCategoryByDayData} />
                            </Grid>

                    }
                    {
                        isViewCollectionMonthlyGrid == false ?
                            <></>
                            :
                            <Grid item xs={12} sm={6}>
                                <ChartCollectionByMonthlyGrid monthData={collectionCategoryMonthlyData} />
                            </Grid>

                    }
                    {
                        isCollectionCatByMonthGrid == false ?
                            <></>
                            :
                            <Grid item xs={12} sm={6}>
                                <ChartCollectionCategoryByMonthGrid catData={collectionCategoryByMonthData} />
                            </Grid>

                    }
                    {
                        isViewCollectionYearlyGrid == false ?
                            <></>
                            :
                            <Grid item xs={12} sm={6}>
                                <ChartCollectionCategoryByYearGrid chartdata={collectionCategoryByYear} />
                            </Grid>

                    }
                    {
                        isViewActivePluckersGrid == false ?
                            <></>
                            :
                            <Grid item xs={12} sm={3}>
                                <ActivePluckersGrid data={activePluckersData} />
                            </Grid>
                    }
                    {
                        isViewActualCollectionGrid == false ?
                            <></>
                            :
                            <Grid item xs={12} sm={3}>
                                <ActualCollectionGrid data={actualCollectionData} />
                            </Grid>
                    }
                    {
                        isViewCheckRoleCollectionGrid == false ?
                            <></>
                            :
                            <Grid item xs={12} sm={3}>
                                <CheckRoleCollectionGrid data={checkRoleCollection} />
                            </Grid>
                    }
                    {
                        isViewCheackRollGtnGrnDetailsGrid == false ?
                            <></>
                            :
                            <Grid item xs={12} sm={3}>
                                <CheckRoleGtnGrnVariance data={cheackRollGtnGrnDetails} />
                            </Grid>
                    }
                    {
                        isViewEstateCollectionByDayGrid == false ?
                            <></>
                            :
                            <Grid item xs={12} sm={6}>
                                <ChartEstatetCollectionByDayGrid chartdata={estateCollectionByDayData} />
                            </Grid>

                    }
                    {
                        isViewEstateCollectionByMonthGrid == false ?
                            <></>
                            :
                            <Grid item xs={12} sm={6}>
                                <ChartEstateCollectionByMonthGrid bardata={estateCollectionByMonthData} />
                            </Grid>

                    }
                    {
                        isViewDivisionCollectionByMonthGrid == false ?
                            <></>
                            :
                            <Grid item xs={12} sm={6}>
                                <ChartDivisionCollectionByMonthGrid bardata={divisionCollectionByMonthData} />
                            </Grid>
                    }

                </Grid>
            </div>

        </Fragment>
    );
}
